<template>
  <content-items-edit
    content-type="trial-playlists"
    content-type-singular="trial-playlist"
    content-name="Trial Playlists"
    content-name-singular="Trial Playlist"
  />
</template>

<script>
import ContentItemsEdit from '@/views/content-item/content-items-edit/ContentItemsEdit.vue'
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
    ContentItemsEdit,
  },
}
</script>

<style scoped>

</style>
